export interface ListPageParams {
  cursor?: string | null;
  limit?: number;
}

export function listQueryString(params: ListPageParams = {}): string {
  const { cursor, limit = 50 } = params;
  const search = new URLSearchParams({ limit: String(limit) });
  if (cursor) {
    search.set('cursor', cursor);
  }
  return search.toString();
}
